import { Fragment, type FC } from 'react';

import { LoadingPage } from '#packages/web/layouts/page/templates/loading';
import { type ViewModelProps } from '#packages/web/types/view-model-props';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type UserProfilePageViewModel } from './user-profile-page.view-model';
import { GuestUserProfilePageRenderer } from './guest-user-profile-page.renderer';
import { SignedInUserProfilePageRenderer } from './signed-in-user-profile-page.renderer';

export type UserProfilePageContainerProps =
  ViewModelProps<UserProfilePageViewModel>;

export const UserProfilePageContainer: FC<UserProfilePageContainerProps> = ({
  viewModel: { page },
}) => (
  <Fragment>
    {/* Loading */}
    {page.state === 'loading' && <LoadingPage />}

    {/* Guest */}
    {page.state === 'guest' && (
      <GuestUserProfilePageRenderer onSignIn={page.onSignIn} />
    )}

    {/* Signed In */}
    {page.state === 'signed-in' && (
      <SignedInUserProfilePageRenderer
        onSignOut={page.onSignOut}
        userProfile={page.userProfile}
      />
    )}

    {/* Signed In - No Profile */}
    {page.state === 'signed-in-no-profile' && (
      <SignedInUserProfilePageRenderer
        onSignOut={page.onSignOut}
        userProfile={{
          firstName: '-',
          lastName: '-',
          fullName: '- -',

          avatarText: '--',
          email: '--',
        }}
      />
    )}

    {/* Error */}
    {page.state === 'error' && <ThrowError error={page.error} />}
  </Fragment>
);
